// extracted by mini-css-extract-plugin
export default {"row":"style_row__h6WQy","animatedColumn":"style_animatedColumn__++Yb+","moving-gradient":"style_moving-gradient__IyO5M"};